module.exports = __webpack_public_path__ + "static/media/undraw_maker_launch_crhe.d56aac55.png";